import React, { useEffect, useState } from "react";
import { Switch, Redirect, Route } from "react-router-dom";

import { FixedHeader, PrimaryHeader } from "../../ui/Header";
import ButtonGroup from "../../ui/ButtonGroup/ButtonGroup";

import * as urls from "../../utils/urls";

import CommonCategory from "./CommonCategory";
import { CategoriesContext } from "./CategoriesContext";
import useSearch from "../../hooks/useSearch";
import { categoryGroups } from "../../constants";
import { CategoriesService } from "../../utils/api";
import { MpaaRatings } from "./MpaaRatings";

const Category = ({ location, history }) => {
  const [search, setSearch] = useSearch(
    { group: categoryGroups.exchange },
    location,
    history
  );
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    setLoading(true);

    CategoriesService({ group: search.group })
      .then(data => {
        setData(data);
      })
      .catch(e => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [search]);

  return (
    <div className="category-page">
      <FixedHeader>
        <PrimaryHeader>
          <span className="header__title">Анонсы и категории</span>
          <ButtonGroup
            items={[{ title: "Категории", code: urls.categoriesCommon() }]}
            theme="dark"
            nav
          />
          {data?.mpaa_ratings && (
            <MpaaRatings mpaa_ratings={data.mpaa_ratings} />
          )}
        </PrimaryHeader>
      </FixedHeader>
      <div className="content-body content-body__with-fixed">
        <CategoriesContext.Provider
          value={{
            search,
            setSearch,
            loading,
            data
          }}
        >
          <Switch>
            <Redirect
              from={urls.categories()}
              to={urls.categoriesCommon()}
              exact
            />
            <Route path={urls.categoriesCommon()} component={CommonCategory} />
          </Switch>
        </CategoriesContext.Provider>
      </div>
    </div>
  );
};

export default Category;
